import React from "react";
import { Tag } from "antd";
import { connect } from "react-redux";

import { setPopup } from "../../actions/popupAction";

import {
  ErrorMessageIcon,
  ErrorYellowIcon,
  SuccessMessageIcon,
} from "../../assets/svg";
import "./styles.scss";
import useWindowDimensions from "../custom-hooks/useWindowDimensions";
import { MOBILE_WIDTH } from "../../constants/constants";

const CustomNotification = (props) => {
  const {
    messageType,
    message,
    customerName,
    tableName,
    assignedTo,
    dispatch,
  } = props;

  const handleRemove = () => {
    dispatch(setPopup({ customPopupMessage: false }));
  };

  const { width } = useWindowDimensions();

  const getMessageType = (type) => {
    switch (type) {
      case "add":
        return `${customerName} has been added to the ${tableName} list.`;
      case "update":
        return `${customerName} has been updated.`;
      case "delete":
        return `${customerName} has been deleted from the ${tableName} list.`;
      case "activate":
        return `${customerName} has been activated from the ${tableName} list.`;
      case "deactivate":
        return `${customerName} has been deactivated from the ${tableName} list.`;
      case "archived":
        return `${customerName} has been archived from the ${tableName} list.`;
      case "unarchive":
        return `${customerName} has been unarchived from the ${tableName} list.`;
      case "assigned":
        return `${customerName} has been assigned to ${assignedTo}`;
      case "csv":
        return `${customerName} file has been uploaded `;
      case "call":
        return `${customerName} has been started `;
      case "copy":
        return `${customerName} has been copied `;
      case "success":
        return message;
      case "info":
        return message;
      case "csverror":
        return `Please use a correct data format for CSV file upload. `;
      case "error":
        return `${message}`;
      default:
        return "Something went wrong";
    }
  };

  return (
    <Tag
      className={`notification-container ${
        messageType === "error" ||
        messageType === "csverror" ||
        messageType === undefined
          ? "error-notification"
          : ""
      } ${messageType === "info"} ${
        width > MOBILE_WIDTH ? "" : "mobile-width"
      }`}
      closable
      onClose={handleRemove}
    >
      <span className={`notification-text`}>
        {messageType === "add" ||
        messageType === "update" ||
        messageType === "delete" ||
        messageType === "activate" ||
        messageType === "deactivate" ||
        messageType === "assigned" ||
        messageType === "archived" ||
        messageType === "unarchive" ||
        messageType === "call" ||
        messageType === "copy" ||
        messageType === "csv" ||
        messageType === "success" ? (
          <p className="message-status">
            {SuccessMessageIcon} <span className="status">Successful!</span>
          </p>
        ) : messageType === "info" ? (
          <p className="message-status">
            {ErrorYellowIcon}
            <span className="status">Warning!</span>
          </p>
        ) : (
          <p className="message-status">
            {ErrorMessageIcon}
            <span className="status">Error!</span>
          </p>
        )}
        <h6
          className={
            width > MOBILE_WIDTH ? "message-content" : "message-content mobile"
          }
        >
          {getMessageType(messageType)}
        </h6>
      </span>
    </Tag>
  );
};

export default connect()(CustomNotification);
